import { lveaOptions, SelectOption } from "../utilities/dropDownOptions";


export const dynamicSelectOptionsMapTemplate = {
            vehiclePrograms: [],
            lveas: lveaOptions,
            supplier: [{
                label: "--Please select--",
                value: "",
            }],
            clusterUrl: [{
                label: "--Please select--",
                value: "",
            }],
};

export interface DynamicSelectOptionsMapTemplateInterface {
    vehiclePrograms: SelectOption[];
    lveas: SelectOption[];
    supplier: SelectOption[];
    clusterUrl: SelectOption[];
}